module.exports = __webpack_public_path__ + "static/media/logo_openflow.3db0207e.svg";